import React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import _useTranslate from '../../hooks/_useTranslate';

const FooterInfoMenu = ({ feathersStore }) => {
    const footer = _useTranslate(feathersStore.language, "footer");

    return (
        <div className="footer-menu-section">
            <h3 className="footer-section-header">{footer.company}</h3>
            <div className="footer-menu-links">
                <Link to="/termsnconditions" className="footer-menu-link">
                    {footer.termsOfService}
                </Link>
                <Link to="/privacypolicy" className="footer-menu-link">
                    {footer.privacyPolicy}
                </Link>
                <Link to="/about" className="footer-menu-link">
                    {footer.aboutUs}
                </Link>
                {feathersStore.settings?.latitude && feathersStore.settings?.longitude && (
                    <a
                        className="footer-menu-link"
                        href={`https://www.google.com/maps/search/?api=1&query=${feathersStore.settings.latitude},${feathersStore.settings.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {footer.findUs}
                    </a>
                )}
            </div>
        </div>
    );
};

export default inject('feathersStore')(observer(FooterInfoMenu));